export default "__VITE_ASSET__xj2Xv_mUSfUMgcujKcDLEQ__"